<template>
  <div v-if="site" >

    <h1>{{ potential_site.handle }}</h1>

    <input type="search" v-model="search_value" placeholder="Search"  style="margin-bottom:24px;" />


    <div class="admin__columns">
      <input type="checkbox" v-model="current_display_states" :value="display_state.NOT_SET">
      <label>Unset</label>
    </div>

    <div class="admin__columns">
      <input type="checkbox" v-model="current_display_states" :value="display_state.HIDE_FROM_SITE">
      <label>Rejected</label>
    </div>

    <div class="admin__columns">
      <input type="checkbox" v-model="current_display_states" :value="display_state.SHOW_ON_SITE">
      <label>Approved</label>
    </div>

    <div class="admin__columns">
      <input type="checkbox" v-model="current_display_states" :value="display_state.PROMOTE_ON_SITE">
      <label>Promoted</label>
    </div>

    <div class="admin__columns" style="margin-bottom: 30px;">
      <input type="checkbox" v-model="current_display_states" :value="display_state.POSTED_TO_INSTAGRAM">
      <label>Posted</label>
    </div>

    <div class="admin__columns">
      <a class="admin__button" @click="unsetAllProducts__clicked">Unset All Products</a>
      <a class="admin__button" @click="setProductCategoriesFromTitle__clicked">Set Categories From Title</a>
    </div>

    <div style="margin-bottom: 20px;">
      <a class="admin__link" @click="nextPage__clicked">Next Page</a>
    </div>

    <table class="admin__table" style="min-width: 600px; max-width:1250px;">
      <tr v-for="(product, index) in shopify_products" :key="index" :class="`display-state-background--${display_state_names[product.display_state]}`">
        <td>
          <div>{{index}}</div>
          <img :src="product.small_image_url" style="width:300px;" />

        </td>
        <td style="font-size:14px;">
          <div><router-link :to="admin_site_path(product.potential_shopify_site_document_id)">{{ product.shopify_site_document_id }}</router-link></div>
          <div><a :href="product.origin_url" target="_blank">{{ product.title }}</a></div>
          <div><small>Category:</small></div>
          <div>{{product.category}} - {{product.subcategory}}</div>
          <div><small>Product Type:</small> {{product.product_type}}</div>
          <div><small>Price</small>${{product.variants[0].price}}</div>
          <div><small>Date</small>{{ product.published_at.toDate().toLocaleDateString('en-GB')}}</div>
          <div><small>Vendor:</small> {{product.vendor }}</div>

          <div><small @click="toggleHasCelebrityImage__clicked(product, index)">Has Celebrity Image:</small> {{ product.has_celebrity_image }}</div>
          <div><small @click="setCelebrityName__clicked(product, index)">Celebrity Name:</small> {{ product.celebrity_name }}</div>
          <div><small @click="setCelebrityHandle__clicked(product, index)">Category Handle:</small> {{ product.celebrity_handle }}</div>

          <div class="admin__columns">
            <div>Image: {{ product.main_image_index }}</div>
            <a style="" @click="removeCurrentProductImage__clicked(product)">Remove</a>
          </div>
          <div>
            <a @click.prevent="incrementImageIndex(product, -1)">Prev</a>
            &nbsp;
            <a @click.prevent="incrementImageIndex(product, 1)">Next</a>
          </div>

          <div>{{ displayState(product) }}</div>
          <!--<a class="admin__button admin__button--red" style="width:150px;" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a> -->

          <div class="approvals__columns" style="gap: 4px;">
            <a class="admin__button admin__button--small admin__button--red" v-if="product.display_state != display_state.HIDE_FROM_SITE" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a>

            <a class="admin__button admin__button--small admin__button--dark-green" v-if="product.subcategory && product.display_state != display_state.SHOW_ON_SITE" @click="setDisplayState(product, display_state.SHOW_ON_SITE, index)">Approve</a>

            <a class="admin__button admin__button--small admin__button--dark-green" v-if="product.subcategory && product.display_state != display_state.PROMOTE_ON_SITE" @click="setDisplayState(product, display_state.PROMOTE_ON_SITE, index)">Promote</a>

            <a class="admin__button admin__button--small admin__button--yellow" v-if="product.subcategory" @click="addToSocialPost(product)">Social</a>
          </div>

          <div>
            <small>Add Image</small>
            <input type="file" ref="uploadInput" accept="image/jpg, image/jpeg"  multiple  @change="addImage__changed($event, product, index)">

          </div>

        </td>

        <td>
          <div>

            <div style="display:flex; gap:50px;">
              <div v-for="categories in category_columns">
                <a v-for="(category, category_index) in categories"
                   class="admin__category-link"
                   :class="{'admin__category-link--sublink': category.is_subcategory}"
                   :key="category_index"
                   @click="category__clicked(index, product, category)">
                  <span v-if="category.is_subcategory">{{ category.subcategory }}</span>
                  <span v-else>{{ category.category }}</span>
                </a>
              </div>
            </div>


            <!-- </div> -->

          </div>


          <!--
          <div class="admin__table-columns">
            <div><small>Tags:</small></div>
            <div v-html="product.tags.join('<br />')"></div>
          </div> -->
        </td>


        <!-- <td>
           <div>{{ displayState(product) }}</div>
           <a class="admin__button admin__button--red" @click="setDisplayState(product, display_state.HIDE_FROM_SITE, index)">Reject</a>
           <a class="admin__button" v-if="product.subcategory" @click="setDisplayState(product, display_state.SHOW_ON_SITE, index)">Approve</a>
           <a class="admin__button admin__button--green" v-if="product.subcategory" @click="setDisplayState(product, display_state.PROMOTE_ON_SITE, index)">Promote</a>
         </td> -->

      </tr>
    </table>

    <div style="margin-top: 20px;">
      <a class="admin__link" @click="nextPage__clicked">Next Page</a>
    </div>

    <social-generator ref="social_generator"></social-generator>
  </div>
</template>

<script>

import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import ShopifyProduct from '../../../models/ShopifyProduct'
import Category from "../../../models/Category";
import PotentialShopifySite from "../../../models/PotentialShopifySite";
import ShopifySite from "../../../models/ShopifySite";
import SocialGenerator from "../../../components/admin/social-generator";
import SocialPost from "../../../models/SocialPost";

export default {
  components:{
    SocialGenerator
  },
  data(){
    return{
      storage: getStorage(),
      upload_progress: -1,
      search_value: "",
      site: null,
      potential_site: {},
      show_rejected: false,
      shopify_products: [],
      category_columns: [],
      display_state: ShopifyProduct.DisplayState,
      display_state_names: ShopifyProduct.DisplayState.names(),
      current_display_states:[ShopifyProduct.DisplayState.NOT_SET, ShopifyProduct.DisplayState.SHOW_ON_SITE, ShopifyProduct.DisplayState.PROMOTE_ON_SITE, ShopifyProduct.DisplayState.POSTED_TO_INSTAGRAM],
      site_collection_mappings: [],
    }
  },
  async mounted(){

    let all_categories = Category.toIndentedFlatArray();
    let split_1 = 26;
    let split_2 = 49;
    this.category_columns.push(all_categories.slice(1, split_1));
    this.category_columns.push(all_categories.slice(split_1, split_2));
    this.category_columns.push(all_categories.slice(split_2));

    //this.site_collection_mappings = await SiteCollectionMapping.all();

    await this.setSite();
  },
  computed:{
    potential_shopify_site_document_id(){
      return this.$route.params.document_id;
    },
  },
  watch:{
    async  current_display_states(value){
      this.shopify_products = await ShopifyProduct.productPageForSite(this.site.document_id, this.current_display_states);
    },
    async search_value(value){
      if(value.length > 3) {
        this.shopify_products = await ShopifyProduct.startWithText('handle', this.search_value.trim());
      } else if(value.length === 0){
        this.shopify_products = await ShopifyProduct.productPageForSite(this.site.document_id, this.current_display_states);
      }
    }
  },
  methods: {
    async setSite() {
      this.potential_site = await PotentialShopifySite.get(this.potential_shopify_site_document_id);
      this.site = await ShopifySite.getByPotentialShopifySiteId(this.potential_shopify_site_document_id)
      this.shopify_products = await ShopifyProduct.productPageForSite(this.site.document_id, this.current_display_states);
    },

    displayState(product){

      // let prices = product.variants.map(variant => variant.price);// filter((value, index, self) => self.indexOf(value) === index);
      // Math.min(...prices)
      //return  Math.min(...prices) + ' ' + Math.max(...prices);
      return ShopifyProduct.DisplayState.name(product.display_state) + ': ' + product.display_state;
    },
    subcategoriesForProduct(product){
      return product.category ? this.categories.find( c => c.name == product.category).subcategories : [];
    },
    async setDisplayState(product, display_state, array_index){
      product.display_state = display_state;
      console.log("ds", product.display_state);
      await product.save();

      //this.$set(this.shopify_products[array_index], 'display_state', display_state);
    },
    async nextPage__clicked(event){
      this.shopify_products = await ShopifyProduct.productPageForSite(this.site.document_id, this.current_display_states, this.lastProductPublishedDate() );
      window.scroll({top: 0, left: 0, behavior: 'smooth'});
    },
    async category__clicked(array_index, product, category_object){
      product.category_object = category_object;
      product.display_state = ShopifyProduct.DisplayState.SHOW_ON_SITE;
      //console.log("ds", product.display_state);
      await product.save();
    },
    lastProductPublishedDate(){
      return this.shopify_products.length < 1 ? null : this.shopify_products[this.shopify_products.length - 1].published_at.toDate();
    },
    incrementImageIndex(product, direction){
      product.main_image_index = Math.max(0, Math.min(product.images.length - 1, parseInt(product.main_image_index) + direction));
    },
    async addToSocialPost(product){
      let latestPost = await SocialPost.latestPost();
      await latestPost.addProduct(product)

      product.display_state = ShopifyProduct.DisplayState.PROMOTE_ON_SITE;
      await product.save();

      await this.$refs.social_generator.refresh();
    },
    async addImage__changed(event, product, index){
      let file = event.target.files[0];
      let file_url = window.URL.createObjectURL(file);
      let image_id = (new Date()).getTime();
      let image = new Image();
      image.onload = () => {
        window.URL.revokeObjectURL(file_url);
        this.uploadImage(file, product, image_id).then( download_url => {
         product.images.push({
            id: image_id,
            product_id: product.id,
            position: 0,
            created_at: "2022-02-22T13:09:19-05:00",
            updated_at: "2022-02-22T13:09:19-05:00",
            alt: "celebrity",
            width: image.width,
            height: image.height,
            src: download_url,
            variant_ids: [],
            is_celebrity: true
          });
          product.main_image_index = product.images.length - 1;
          product.save().then(() => {
            alert("Image added");
          });
        });
      };
      image.src = file_url;
    },
    uploadImage(image_data, product, image_id){
      return new Promise( (resolve, reject) => {
        this.upload_progress = 0;

        const storageRef = ref(this.storage,`product_images/${this.site.handle}/${product.handle}__${image_id}.jpg`);
        const uploadTask = uploadBytesResumable(storageRef, image_data);

        uploadTask.on(`state_changed`,
            snapshot => {
              this.upload_progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            },
            error => {
              console.log(error.message);
              this.upload_progress = -1;
              reject(error);
            },
            () => {

              getDownloadURL(uploadTask.snapshot.ref).then((download_url) => {
                console.log('download_url', download_url);
                resolve( download_url);
              });

              this.upload_progress = -1;
            }
        );
      });
    },
    async removeCurrentProductImage__clicked(product){
      if( product.main_image_index >= product.images.length){
        alert("Image index is out of bounds");
        return;
      }
      let image = product.images[product.main_image_index];
      let confirmation = confirm("Are you sure you want to remove image  " + product.main_image_index + " for " + product.title);
      if(confirmation){
        product.images.splice(product.main_image_index, 1);
        product.main_image_index = Math.max(0, Math.min(product.images.length - 1, parseInt(product.main_image_index)));
        await product.save();
        alert("Image removed");
      }
    },
    async toggleHasCelebrityImage__clicked(product, index){
      product.has_celebrity_image = product.has_celebrity_image == undefined ? true : !product.has_celebrity_image;
      await product.save();
      this.$set(this.shopify_products, index, product);
    },
    async setCelebrityName__clicked(product, index){
      product.celebrity_name = prompt("Set Celebrity Name");
      await product.save();
      this.$set(this.shopify_products, index, product);
    },
    async setCelebrityHandle__clicked(product, index){
      product.celebrity_handle = prompt("Set Celebrity Handle");
      await product.save();
      this.$set(this.shopify_products, index, product);
    },
    async unsetAllProducts__clicked(event){

      const confirmed = confirm("Are you sure you want to unset all.")

      if(confirmed) {
        let count = 0;
        for (let product of this.shopify_products) {
         // if(product.title.toLowerCase().includes("pre-loved")) {
            product.display_state = ShopifyProduct.DisplayState.NOT_SET;
            await product.save();
            count++;
          //}
        }
        alert(`${count} products unset`);
      } else{
        alert("Ok, nothing happened")
      }
    },

    async setProductCategoriesFromTitle__clicked(event){
      let count = 0;

      let map_data = [
        { match: 'pre-loved', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'preloved', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'secondhand', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'second hand', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'earring', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'necklace', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'perfume', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'fragrance', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'towel', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'pajama', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },
        { match: 'pyjama', category: 'Hidden', subcategory: 'Hidden', display_state: ShopifyProduct.DisplayState.HIDE_FROM_SITE },

        { match: "tank top", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tanktop", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "singlet", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "cami", category: 'Tops', subcategory: 'Sleeveless Tops', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tee ", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "t-shirt", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "tshirt", category: 'Tops', subcategory: 'Tees', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'jumpsuit', category: 'Jumpsuits', subcategory: 'Jumpsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'playsuit', category: 'Jumpsuits', subcategory: 'Playsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'romper', category: 'Jumpsuits', subcategory: 'Playsuits', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "mini dress", category: 'Dresses', subcategory: 'Mini Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "midi dress", category: 'Dresses', subcategory: 'Midi Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "maxi dress", category: 'Dresses', subcategory: 'Maxi Dresses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "mini skirt", category: 'Skirts', subcategory: 'Mini Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "midi skirt", category: 'Skirts', subcategory: 'Midi Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "maxi skirt", category: 'Skirts', subcategory: 'Maxi Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "shorts", category: 'Bottoms', subcategory: 'Shorts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wide-leg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wideleg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "flare pant", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "wide leg", category: 'Bottoms', subcategory: 'Wide Leg & Flare Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: "overall", category: 'Overalls', subcategory: 'Overalls', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'coat', category: 'Coats & Jackets', subcategory: 'Coats', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bomber jacket', category: 'Coats & Jackets', subcategory: 'Bomber & Puffer Jackets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'blazer', category: 'Coats & Jackets', subcategory: 'Blazer Jackets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'cardigan', category: 'Knitwear', subcategory: 'Cardigans', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweater', category: 'Knitwear', subcategory: 'Sweaters', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'boot', category: 'Shoes', subcategory:'Boots', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'heel', category: 'Shoes', subcategory: 'Heels', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sneaker', category: 'Shoes', subcategory: 'Sneakers', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sandal', category: 'Shoes', subcategory: 'Sandals', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweat shirt', category: 'Loungewear & Activewear', subcategory: 'Sweat Shirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweatshirt', category: 'Loungewear & Activewear', subcategory: 'Sweat Shirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweatpant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sweat pant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'trackpant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'track pant', category: 'Loungewear & Activewear', subcategory: 'Sweat Pants', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'hoodie', category: 'Loungewear & Activewear', subcategory: 'Hoodies', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'hoody', category: 'Loungewear & Activewear', subcategory: 'Hoodies', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'jumper', category: 'Loungewear & Activewear', subcategory: 'Jumpers', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'legging', category: 'Loungewear & Activewear', subcategory: 'Leggings', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'thong', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim set', category: 'Swimwear', subcategory: 'Swim Sets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'bikini set', category: 'Swimwear', subcategory: 'Swim Sets', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim onepiece', category: 'Swimwear', subcategory: 'Swim One Piece', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'swim one piece', category: 'Swimwear', subcategory: 'Swim One Piece', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'kikomo', category: 'Robes & Kikomos', subcategory: 'Robes & Kikomos', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        { match: 'sunglasses', category: 'Accessories', subcategory: 'Sunglasses', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },

        // rowie
        //{ match: 'shirt', category: 'Tops', subcategory: 'Shirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },

        // heavymanners.com
        //{ match: 'underwire top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'tie top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'string top', category: 'Swimwear', subcategory: 'Swim Top', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'tie bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'cheeky bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'full bottom', category: 'Swimwear', subcategory: 'Swim Bottoms', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: 'one piece', category: 'Swimwear', subcategory: 'Swim One Piece', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },
        //{ match: "minnie", category: 'Skirts', subcategory: 'Mini Skirts', display_state: ShopifyProduct.DisplayState.SHOW_ON_SITE },


      ];

      for(let product of this.shopify_products){
        if(product.display_state == ShopifyProduct.DisplayState.NOT_SET){
          let title = product.title.toLowerCase();
          for(let data of map_data){
            if(title.includes(data.match)) {
              product.category = data.category;
              product.subcategory = data.subcategory;
              product.display_state = data.display_state;
              await product.save();
              count++;
              break;
            }
          }
        }
      }
      alert(`${count} categories set from titles`);
    }
  }
}
</script>
